<template lang="pug">
  .MediaCarousel
    swiper(:options="swiperOption" ref="swiperEl" @transitionStart="transitionEndHandler")
      swiper-slide.MediaCarousel_slide(v-for="(item, index) in limitItem", :key="item.id")
        slot(v-bind:item="item")
          | Slide {{index + 1}}
      .MediaCarousel_navBtn.MediaCarousel_navBtn-prev(slot="button-prev")
      .MediaCarousel_navBtn.MediaCarousel_navBtn-next(slot="button-next")
    MediaLegend(
      :transitionDirection="carouselDirection"
      :currentIndex="carouselCurrentIndex"
      :items="legendItems"
    )
</template>

<script>

import MediaLegend from '@/components/MediaLegend'
import Model from '@/models/Model'

export default {
  components: {
    MediaLegend
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    itemTitleProperty: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      swiperOption: {
        // loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        speed: 1200,
        navigation: {
          nextEl: '.MediaCarousel_navBtn-next',
          prevEl: '.MediaCarousel_navBtn-prev'
        }
      },
      maxSlide: 9,
      carouselDirection: 1,
      carouselCurrentIndex: 0
    }
  },
  computed: {
    // get swiper controller
    swiperCtrl () {
      return this.$refs.swiperEl.swiper
    },
    itemsHasObjects () {
      return this.items[0].hasOwnProperty('get')
        ? this.items
        : this.items.map(item => new Model(item))
    },
    legendItems () {
      return this.itemsHasObjects.map(item => item.get(this.itemTitleProperty)).slice(0, this.maxSlide)
    },
    limitItem () {
      return this.items.slice(0, this.maxSlide)
    }
  },
  methods: {
    /**
     * Callback lorsque le carousel change de slide
     */
    transitionEndHandler () {
      this.carouselDirection = this.swiperCtrl.previousIndex < this.swiperCtrl.activeIndex ? 1 : -1
      this.carouselCurrentIndex = this.swiperCtrl.realIndex
    }
  }
}
</script>

<style lang="stylus" scoped>

.MediaCarousel

  &_slide
    width 50vw
    margin: 0 10px
    position: relative

    picture
      max-width: 750px;
      position: relative;
      display: block;
      margin: 0 auto;

    @media $mq_m
      width 45vw
      margin: 0 7.5vw

    &::after
      content ''
      position: absolute
      top 0
      right 0
      bottom 0
      left 0
      background-color $black
      opacity: 0
      pointer-events none
      transition: opacity .8s $ease

    &.swiper-slide-prev,
    &.swiper-slide-next
      &::after
        opacity: .75

  &_navBtn
    z-index: 2
    position: absolute
    top 0
    bottom 0
    width 'calc(25vw - 20px - %s)' % ($menu_bar_width_mobile / 2)
    display: flex
    align-items: center
    justify-content: flex-start
    padding: 0 10px
    box-sizing: border-box
    cursor: pointer
    transition: opacity .6s $ease

    @media $mq_m
      width 'calc(12.5vw - %s)' % ($menu_bar_width / 2)
      padding: 0 25px

    circle_size = 8px

    &::before
      content ''
      display: block
      width: circle_size
      height: circle_size
      border-radius: (circle_size/2)
      background-color $beige

    &::after
      content ''
      display: block
      width: 50%
      height: 1px
      background-color $beige
      transition: width .6s $ease

    &-prev
      left 0
      flex-direction: row-reverse

    &-next
      right 0
      flex-direction: row

    &:hover
      &::after
        width: 'calc(100% - %s)' % circle_size

    &.swiper-button-disabled
      opacity 0
      pointer-events: none
      cursor: default

</style>

<style lang="stylus">
/**
 * ATTENTION - STYLES NOT SCOPED
 */

.MediaCarousel

  &_slide

    picture
      max-width: 750px;
      position: relative;
      display: block;
      margin: 0 auto;

      img
        display: block
        margin 0 auto
        width 100%
        height auto
</style>
